import { useQuery } from '@based/sdk/react'
import { createContext, FC, ReactNode, useContext } from 'react'
import { UiSchema } from '../../types/schema.js'

export type BasedUiEndpoints = {
  query: string
  schema: string
  update: string
  create: string
  delete: string
  users: string
  user: string
  copy: string
}

const defaultEndpoints: BasedUiEndpoints = {
  query: 'ui-query',
  schema: 'ui-schema',
  update: 'ui-update',
  create: 'ui-create',
  delete: 'ui-delete',
  users: 'ui-users',
  user: 'ui-user',
  copy: 'ui-copy',
}

const Ctx = createContext(defaultEndpoints)

export const useBasedEndpoints = () => useContext(Ctx)

export const useBasedQuery = (
  payload?: any,
  opts?: {
    persistent: boolean
  },
) => {
  const { query } = useBasedEndpoints()
  return useQuery(query, payload, opts)
}

type UseBasedQuery = Omit<ReturnType<typeof useBasedQuery>, 'data'>

export const useBasedSchema: () => ReturnType<typeof useBasedQuery> = () => {
  const { schema } = useBasedEndpoints()
  return useQuery(schema)
}

export const BasedUiEndpointsProvider: FC<{
  children: ReactNode
  endpoints?: Partial<BasedUiEndpoints>
}> = ({ children, endpoints = defaultEndpoints }) => {
  return (
    <Ctx.Provider value={{ ...defaultEndpoints, ...endpoints }}>
      {children}
    </Ctx.Provider>
  )
}
